export const WINDOW_INNER_HEIGHT: number = -1;
export const HOME_TITLE: string = "Trape";
export const MODE_AVAILABLE: string = "available";
export const MODE_UNAVAILABLE: string = "unavailable";
